import { GetAccountsPositionsHistoryResponse } from '@goldwasserexchange/actor/rest-services';
import { AccountHistory } from '../../../accounts/history/type';

export function getHistoryLineId(line: GetAccountsPositionsHistoryResponse): number
export function getHistoryLineId(line: AccountHistory): string
export function getHistoryLineId(line: AccountHistory | GetAccountsPositionsHistoryResponse): string | number {
  return line['HIS_MVT.ID'];
}
